import React from "react";

const CustomInputRangeDatePicker = React.forwardRef(({ value, onClick}, ref) => (
  <li onClick={onClick} ref={ref}>
    Custom Range
  </li>
));

export default CustomInputRangeDatePicker;